module.exports = __webpack_public_path__ + "img/layer_zip.e9a5714f.jpg";